export class RestoreAzureSqlDatabaseNativePitrRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetDatabaseName",
            "baseName": "targetDatabaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreToTime",
            "baseName": "restoreToTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "targetServerName",
            "baseName": "targetServerName",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetResourceGroup",
            "baseName": "targetResourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureSqlDatabaseNativePitrRequest.attributeTypeMap;
    }
    constructor() {
    }
}
